import React from 'react';
import { useBrokerConnectionGuard } from '../../hooks/useBrokerConnectionGuard';
import { useRedirectLogic } from '../../hooks/useRedirectLogic';

const BrokerConnectionGuard = ({ children }) => {
  // Use custom hooks for cleaner separation of concerns
  const guardState = useBrokerConnectionGuard();
  const redirectLogic = useRedirectLogic(guardState);

  // Debug logging removed to prevent infinite re-renders

  // Don't show loading screen - just render children immediately
  // The guard will handle redirects in the background
  return children;
};

export default BrokerConnectionGuard;
